// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__p_n5r","productName":"Table_productName__3E5aV"};